import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email, password);
            toast.success(`Welcome back, ${u.name}`);
            nav(u.role === "admin" ? "/admin" : u.role === "owner" ? "/owner" : "/centers");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[calc(100vh-4rem)] grid md:grid-cols-2">
            <div className="hidden md:block relative bg-[#0A0B10] text-white overflow-hidden">
                <img
                    src="https://images.unsplash.com/photo-1514369118554-e20d93546b30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxzdHVkZW50JTIwZm9jdXN8ZW58MHx8fHwxNzg1MTgyNjM2fDA&ixlib=rb-4.1.0&q=85"
                    alt="Student focused, ready for the mock"
                    className="absolute inset-0 h-full w-full object-cover opacity-60 grayscale"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#0A0B10]/70 via-[#0A0B10]/50 to-[#0A0B10]/90" />
                <div className="absolute inset-0 bg-grid opacity-15" />
                <div className="relative h-full p-12 flex flex-col justify-between">
                    <div className="overline text-white/70">BookedSlot / Login</div>
                    <div>
                        <h1 className="font-heading text-4xl font-black tracking-tight leading-tight">Sit for a mock. Feel the pressure.</h1>
                        <p className="mt-4 text-white/70 max-w-md leading-relaxed">A quiet desk, a locked timer and a real invigilator — the way your final exam actually feels.</p>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center p-8">
                <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
                    <div>
                        <div className="overline mb-2">Welcome back</div>
                        <h2 className="font-heading text-3xl font-bold">Sign in</h2>
                    </div>
                    <div className="space-y-2">
                        <Label htmlFor="email">Email</Label>
                        <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-sm" data-testid="login-email" />
                    </div>
                    <div className="space-y-2">
                        <Label htmlFor="password">Password</Label>
                        <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-sm" data-testid="login-password" />
                    </div>
                    <Button type="submit" disabled={loading} className="w-full rounded-sm bg-primary hover:bg-primary/90" data-testid="login-submit">
                        {loading ? "Signing in…" : "Sign in"}
                    </Button>
                    <div className="text-sm text-muted-foreground text-center">
                        No account? <Link to="/register" className="text-primary underline" data-testid="go-register">Create one</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
